module.exports = __webpack_public_path__ + "static/img/news7.396fced.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news7.png
// module id = 4ed1
// module chunks = 1